import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        compuestoQuimico: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.compuestoQuimico}
            </SoftTypography>
          </SoftBox>
        ),
        unidad: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.unidad}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.estado}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadAnual: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.cantidadAnual}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  {
    name: "compuestoQuimico",
    desc: "Compuesto Químico",
    align: "center",
    noOrder: true,
    width: "1%",
  },
  { name: "cantidadAnual", desc: "Cantidad Anual", align: "left", noOrder: true },
  { name: "estado", desc: "Estado", align: "left", noOrder: true },
];

export default { columns, getRows };
